export default __webpack_public_path__ + "static/media/emaily.a10647ac.png";